import api from '../api';
import { ParkingResponse } from '../models/parking';

const baseUrl = 'pwa/parking';
export class ParkingService {
  public list = (date: string, building_id: number) =>
    api.get<ParkingResponse[]>(
      `${baseUrl}/available?buildingId=${building_id}&date=${date}`
    );
}

const parkingService = new ParkingService();
export default parkingService;
